import React from 'react';
import { Box, Typography } from '@mui/material';
import { IPD_COLORS } from './ipdColors';

/** Key-value detail row for detail pages. */
export default function IpdDetailRow({ label, value, children }) {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '130px 1fr', columnGap: 2, rowGap: 0.25, mb: 1.5, alignItems: 'start' }}>
      <Typography sx={{ color: IPD_COLORS.textSecondary, fontSize: 12, lineHeight: 1.5 }}>
        {label}
      </Typography>
      <Typography sx={{ color: IPD_COLORS.textPrimary, fontSize: 13, lineHeight: 1.5, wordBreak: 'break-word' }}>
        {children ?? value ?? '—'}
      </Typography>
    </Box>
  );
}
